import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, NgForm } from '@angular/forms';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { AuthService, DialogModalService, ValidatorsService } from 'src/app/services';
import { ForgotPasswordComponent } from '../../dialog/registration/authentication/forgot-password/forgot-password.component';
import { LoginValidator } from './login.validator';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  progressRef: NgProgressRef;
  errorMessages: any;
  showPass: boolean;
  errorMessage: string
  authForm: UntypedFormGroup = this.fb.group({
    login: [null, this.validator.login],
    password: [null, this.validator.password],
  });

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private validator: LoginValidator,
    private validatorService: ValidatorsService,
    private dialogModal: DialogModalService
  ) { }

  ngOnInit() {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;

    this.authService.listenerErrorMessageError().subscribe(value => {

      if (value) {

        this.errorMessage = value;
      }
    });
  }

  ngOnDestroy(): void {
  }


  /**
   * 
   * @param event 
   * @param form 
   */
  loginByEnter(event, form: NgForm) {

    if (event.keyCode == 13) {
      this.login(form);
    }
  }


  /**
   * 
   * @param form 
   */
  login(form: NgForm): void {

    this.authService.login(this.authForm.value, this.progressRef, form);
  }


  /**
   * 
   * @param field 
   * @param type 
   */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.authForm.get(field), type);
  }


  /**
   * 
   * @param field 
   */
  checkingFieldStatus(field: string): string {

    return this.validatorService.checkingFieldStatus(this.authForm.get(field));
  }

  password() {

    this.showPass = !this.showPass;
  }


  /**
   * 
   */
  forgotPass() {

    let data = {
      email: this.login
    }

    this.dialogModal.open(data, ForgotPasswordComponent, 'lg').then(

      (result) => {

        if (result) {

        }
      },
      () => { console.log('Rejected!'); }
    );

  }
}
